var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58994 9.75109C8.23825 11.0765 9.31263 12.146 10.641 12.7883C10.7382 12.8343 10.8457 12.8543 10.9529 12.8462C11.0602 12.838 11.1635 12.8021 11.2526 12.742L13.2085 11.4377C13.295 11.3801 13.3945 11.3449 13.4981 11.3354C13.6016 11.3259 13.7059 11.3423 13.8015 11.3833L17.4606 12.9515C17.5849 13.0043 17.6887 13.096 17.7563 13.213C17.8239 13.3299 17.8517 13.4656 17.8355 13.5997C17.7198 14.5047 17.2782 15.3365 16.5935 15.9394C15.9087 16.5422 15.0276 16.8748 14.1152 16.8749C11.2973 16.8749 8.5948 15.7555 6.60223 13.7629C4.60965 11.7703 3.49023 9.06782 3.49023 6.24989C3.49028 5.33753 3.82289 4.45647 4.42577 3.77167C5.02865 3.08688 5.86046 2.64531 6.76547 2.52966C6.89954 2.51343 7.03526 2.54122 7.15217 2.60883C7.26907 2.67644 7.36084 2.78022 7.41365 2.90452L8.98322 6.56685C9.02382 6.66158 9.04036 6.76488 9.03137 6.86755C9.02238 6.97022 8.98815 7.06908 8.93171 7.15531L7.63199 9.14123C7.57284 9.23056 7.53787 9.33372 7.5305 9.44061C7.52313 9.5475 7.54361 9.65448 7.58994 9.75109V9.75109Z",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6e4691e22c68d632fdbb5a53d8cf545e.svg";
export { ForwardRef as ReactComponent };